export const RETIRO_FONDO_LIBRE_CHANGE_PAGE_EXITOSO = 'RETIRO_FONDO_LIBRE_CHANGE_PAGE_EXITOSO';
export const RETIRO_FONDO_LIBRE_CHANGE_PAGE_ERROR = 'RETIRO_FONDO_LIBRE_CHANGE_PAGE_ERROR';
export const RETIRO_FONDO_LIBRE_CHANGE_PAGE_LOADING = 'RETIRO_FONDO_LIBRE_CHANGE_PAGE_LOADING';
export const RETIRO_FONDO_LIBRE_CHANGE_PAGE_CLEANER = 'RETIRO_FONDO_LIBRE_CHANGE_PAGE_CLEANER';
export const RFL_SET_DATA_EXITOSO = 'RFL_SET_DATA_EXITOSO';
export const RFL_NEXT_PAGE_EXITOSO = 'RFL_NEXT_PAGE_EXITOSO';
export const RFL_BACK_PAGE_EXITOSO = 'RFL_BACK_PAGE_EXITOSO';
